import api from '@/api';

export default {
    /**
     * 나의 일정트리를 가저옵니다
     * @param {string} parendId root Folder ID
     */
    getMyFolderItems(parentId?: string): Promise<ItemList<calendar.Folder>> {
        return api
            .post({
                url: '/api/ews/Dynamic/list?funcName=getMyFolderItems',
                data: {
                    fields: [
                        { key: 'Id' },
                        { key: 'ParentFolderId' },
                        { key: 'ChildFolderCount' },
                        { key: 'DisplayName' },
                        { key: 'WellKnownFolderName' },
                        { key: 'UnreadCount' },
                        { key: 'USER_IS_FAVORITE' },
                        { key: 'USER_RENDER_ORDER' },
                        { key: 'USER_COLOR' },
                    ],
                    filters: [
                        {
                            operator: 'or',
                            filters: [
                                {
                                    key: 'FolderClass',
                                    value: 'IPF.Appointment',
                                    condition: 'isEqualTo'
                                },
                                {
                                    key: 'FolderClass',
                                    value: 'IPF.Appointment.Birthday',
                                    condition: 'isEqualTo'
                                }
                            ]
                        },
                        {
                            key: 'PR_ATTR_HIDDEN',
                            value: 'false',
                            condition: 'isEqualTo'
                        }
                    ],
                    parentId: parentId, // 최초 로드시 기본 목록을 가져오기 위해 null 상태임
                    wellKnownParentName: 'MsgFolderRoot', // parentId가 null이 아닌 경우 이 값은 무시됨. 기본 폴더 목록 가져오기 위함.
                    type: 'Folder',
                    Traversal: "Deep"
                }
            })
            .then((res: any) => {
                return res.items.map((item: calendar.Folder, idx: number) => {
                    var rlt = {
                        ...item,
                        selected: false,
                        index: idx,
                        root_index: 0,
                        checked: false,
                        events: [],
                        isEWS: true,                        
                    };
                    return rlt;
                });
            })
    },

    /**
     * 공유 폴더를 가져옵니다
     */
    getSharedFolders(): Promise<ItemList<calendar.Folder>> 
    {
        return api
        .post({
            url: '/api/ews/Calendar/getsharedfolders?funcName=getSharedFolders',
        }).then((res: any) => {
            return res.map((item: calendar.Folder, idx: number) => {
                var rlt = {
                    ...item,
                    selected: false,
                    index: idx,
                    root_index: 0,
                    checked: false,
                    events: [],
                    isEWS: true,
                    isShared: true,
                };
                return rlt;
            });
        });
    },

    setFolderPermission(item: calendar.CalendarPermissionRequest) {
        return api
        .post({
            url: '/api/ews/Calendar/setfolderpermission?funcName=setFolderPermission',
            data: {
                EwsFolderID: item.EwsFolderID || null,
                EwsFolderName: item.EwsFolderName || null,
                CalendarPermissionUsers: item.CalendarPermissionUsers || null,
            } as calendar.CalendarPermissionRequest
        })
    },

    /**
     * 현재 공유된 사용자를 가져옵니다
     */
    getSharedUsers(folderId: string): Promise<Array<any>>
    {
        return api
        .post({
            url: '/api/ews/Calendar/getsharedusers?funcName=getSharedUsers',
            data: {
                id: folderId,
            }
        })
    },

    getFolder(id?: string): Promise<calendar.Folder> {
        return api
            .post<any>({
                url: "/api/ews/dynamic/get?funcName=getFolder",
                data: {
                    fields: [
                        { key: 'Id' },
                        { key: 'ChildFolderCount' },
                        { key: 'DisplayName' },
                        { key: 'WellKnownFolderName' },
                        { key: 'UnreadCount' },
                        { key: 'USER_IS_FAVORITE' },
                        { key: 'USER_RENDER_ORDER' },
                        { key: 'USER_COLOR' },
                    ],                    
                    ItemId: id,
                    type: 'Folder',
                },
            })
            .then((res) => {
                res.item.isEWS = true;
                return res.item;
            });
    },

    /**
     * 일정폴더명을 수정합니다
     * @param {calendar.Folder} folder 업데이트할 폴더
     */
    editFolderName(folder: calendar.Folder) {
        return api.post({
            url: '/api/ews/Dynamic/set?funcName=editFolderName',
            data: {
                fields: [                    
                    { key: 'DisplayName', value: folder.displayName },
                ],
                id: folder.id,
                type: 'Folder',
            },
        });
    },

    /**
     * 일정폴더색을 수정합니다
     * @param {calendar.Folder} folder 업데이트할 폴더
     */
    editFolderColor(folder: calendar.Folder) {
        return api.post({
            url: '/api/ews/Dynamic/set?funcName=editFolderColor',
            data: {
                fields: [                    
                    { key: 'USER_COLOR', value: folder.colorCode || 'none' },
                ],
                id: folder.id,
                type: 'Folder',
            },
        });
    },

    /**
     * 일정 폴더를 추가합니다.
     * @param {string} parentId
     * @param {string} name
     */
    addFolder(parentId: string, name: string): Promise<string> {
        return api
            .post({
                url: '/api/ews/Folder/create?funcName=',
                data: {
                    id: parentId,
                    name: name,
                },
            })
            .then((result: any) => result.item.id);
    },

    /**
     * 일정 폴더를 삭제합니다.
     * @param {object} id 선택한 일정 폴더 ID [ id ]
     */
    deleteFolder(id: Array<string>) {
        return api.delete({
            url: '/api/ews/Folder?funcName=deleteFolder',
            data: id,
        });
    },    
}